import { render, staticRenderFns } from "./configurable-material-selector-modal.vue?vue&type=template&id=742ffe45&scoped=true"
import script from "./configurable-material-selector-modal.vue?vue&type=script&lang=ts"
export * from "./configurable-material-selector-modal.vue?vue&type=script&lang=ts"
import style0 from "./configurable-material-selector-modal.vue?vue&type=style&index=0&id=742ffe45&prod&scoped=true&lang=css"
import style1 from "./configurable-material-selector-modal.vue?vue&type=style&index=1&id=742ffe45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ffe45",
  null
  
)

export default component.exports